import * as React from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * Whether the layout viewport is narrower than a breakpoint.
 * @param breakpoint - Width in px at which the layout stops counting as mobile; the `md:` one by default.
 * @returns True below the breakpoint.
 */
export function useMobile(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    // The query's own answer, so this agrees with the `md:` styles. `innerWidth` is the visual
    // viewport, which a pinch zoom narrows without any media query changing.
    const onChange = () => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return !!isMobile;
}
